export const transformText = (message, syncUser) => {
  return message.replace(/({Profile:FirstName})/g, `${syncUser?.firstName}`);
};
